import { filterLocalizedLifeAreas } from '@griply/utils';
import { useSortedGoals } from 'features/goals';
import { useSortedLocalizedLifeAreas } from 'features/life-areas';
import { useMemo } from 'react';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUser } from 'shared/hooks/use-user';
import { Goal } from 'shared/types/goal';

export const useFilteredLocalizedLifeAreas = (goals: Goal[]) => {
  const user = useUser();
  const lifeAreas = useSortedLocalizedLifeAreas();
  const allGoals = useSortedGoals();
  const links = useEntityLinks();
  const showEmptyLifeAreas =
    !!user?.settings?.goalsOverview?.roadmap?.showEmptyLifeAreas;

  return useMemo(
    () =>
      filterLocalizedLifeAreas(lifeAreas, {
        goals,
        allGoals,
        links,
        showEmptyLifeAreas,
      }),
    [goals, allGoals, lifeAreas, links, showEmptyLifeAreas],
  );
};
